module.exports = __webpack_public_path__ + "static/media/m+a-2.cceaaae1.svg";